import React from 'react';
import Page from "components/Page";
import Map from 'components/Map';
import {useOperator} from "../../../context/OperatorContext";
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
import 'mapbox-gl/dist/mapbox-gl.css';
import "services/mabox-gl";

// Page ----

export function SiteMap() {
  const {settings, termFor} = useOperator()

  const breadcrumbs = {
    "Operations": '/',
    [`${termFor('Site')} Map`]: '/map',
  }

  return (
    <Page title={`${termFor('Site')} Map`} breadcrumbs={breadcrumbs}>
      <div className="relative shadow-md rounded-md overflow-hidden">
        <Map
          height={'80vh'}
          defaultMapStyle={settings?.audience_app.map_style ?? null}
          initialViewState={settings?.audience_app.map_state ?? null}
          hidePointsOfInterest
          showSiteSelector
        />
      </div>
    </Page>
  );
}